import axios from "axios";

import axiosServices from "../utils/axios";

export const fetchSofDocuments = async (
    page: number,
    pageSize: number,
    jobId?: string
  ) => {
    const response = await axiosServices.get("/csofdocs", {
      params: {
        page: page + 1,
        start: page * pageSize,
        limit: pageSize,
        ...(jobId && { job_id: jobId }),
      },
    });
    return (response.data);
  };

  export const createSofDocument = async (data: {
    cargo_id: string;
    job_id: string;
    berth_id: string;
  }) => {
    const response = await axiosServices.post(`/csofdocs`, data);
    return response.data;
  };
  export const deleteSofDocument = async (csofId:string) => {
    const response = await axiosServices.delete(`/csof/${csofId}`);
    return response.data;
  };
  
  export const uploadSignedUrl = async (params:any) => {
    const response = await axiosServices.get("/signed_url", { params });
    return response.data;
  };
  
  export const extractSofData = async (csofId:string, data:any ) => {
    const response = await axiosServices.put(`/csof/${csofId}`, data);
    return response.data;
  };

  export const formatOverride = async (csofId: string, companyFormat: string) => {
    const response = await axiosServices.patch(`/csof/${csofId}/format`, {
      company_format: companyFormat,
    });
    return response.data;
  };

  export const regenerateSofDocument = async (csofId: string) => {
    const response = await axiosServices.post(`/csof/${csofId}/regenerate`);
    return response.data;
  };

  export const fetchSingleCsof = async (csofId: string) => {
    const response = await axiosServices.get(`/csof/${csofId}`);
    return response.data;
  };

  export const fileUpload = async (file: Blob, type: string, name: string, jobId?: string) => {
    const response = await axiosServices.get("/signed_url", {
      params: {
        ContentType: type,
        key: name,
        operation: "put",
        ...(jobId && { jobId }),
      },
    });
  
    if (response.status !== 200) {
      throw new Error(`Failed to get signed URL: ${response.statusText}`);
    }
  
    const signedUrl = response.data.data.pre_signed_url;
  
    const uploadResponse = await axios.put(signedUrl, file, {
      headers: {
        "Content-Type": type,
      },
    });
  
    if (uploadResponse.status !== 200) {
      throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
    }
  
    return {
      success: true,
      fileUrl: signedUrl.split("?")[0], // Return the base URL without query parameters
    };
  };

  // JavaScript + React-style file upload handler with progress bar support

  export const handleFileDrop = async (event: any, options: any) => {
    event.preventDefault();
  
    const {
      cargoGrade,
      jobId,
      jobList,
      onProgressUpdate,
      onSuccess,
      onError,
    } = options;
  
    const {files} = event.dataTransfer;
    if (!files.length) return;
  
    const file = files[0];
    const reader = new FileReader();
  
    reader.onload = async (evt: any) => {
      if (evt.target.readyState !== FileReader.DONE) return;
  
      try {
        const arrayBuffer = evt.target.result;
        const blob = new Blob([new Uint8Array(arrayBuffer)], { type: file.type });
  
        const cargo = jobList
          .flatMap((job: any) => job.berths || [])
          .flatMap((berth: any) => berth.calls || [])
          .flatMap((call: any) => call.operations || [])
          .find((op: any) => op.grade === cargoGrade);
  
        if (!cargo) throw new Error("Cargo not found for selected grade");
  
        const cargoId = cargo.cargo_id;
  
        let berthId: string | null = null;
  
        jobList.forEach((job: any) => {
          (job.berths || []).forEach((berth: any) => {
            (berth.calls || []).forEach((call: any) => {
              (call.operations || []).forEach((op: any) => {
                if (op.cargo_id === cargoId && call.berth_id && !berthId) {
                  berthId = call.berth_id;
                }
              });
            });
          });
        });
  
        const { data } = await uploadSignedUrl({
          contentType: file.type,
          key: file.name,
          operation: "put",
        });
  
        const signedUrl = data.pre_signed_url;
  
        // Upload file to S3 using axios
        await axiosServices.put(signedUrl, blob, {
          headers: {
            "Content-Type": file.type,
          },
          onUploadProgress: (progressEvent: any) => {
            if (progressEvent.lengthComputable && typeof onProgressUpdate === "function") {
              const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              onProgressUpdate(percent);
            }
          },
        });
  
        // Trigger SOF data extraction
        await extractSofData(cargoId, {
          berth_id: berthId,
          cargo_id: cargoId,
          jobId,
          key: file.name,
        });
  
        if (typeof onSuccess === "function") onSuccess();
      } catch (err: any) {
        if (typeof onError === "function") onError(err.message || "Upload failed");
      }
    };
  
    reader.readAsArrayBuffer(file);
  };

